<template>
  <span class="custom-icon-exclamation">
    <span v-if="isSelectAllOptionForFilter">(Select All)</span>
    <OctagonX v-else-if="isStopSale" :size="isCompact ? 16 : 20" class="stop-sale-icon" />
    <span v-else>-</span>
  </span>
</template>

<script>
import { OctagonX } from 'lucide-vue';

export default {
  name: 'CustomIconExclamation',
  components: { OctagonX },
  props: {
    value: {
      type: [Boolean, null],
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Für den AG-Grid Set-Filter-Renderer, damit das nicht in jeder datei stehlt
    isSelectAllOptionForFilter() {
      return this.params?.value === '(Select All)';
    },
    resolvedValue() {
      if (this.params) {
        return this.params.value !== undefined
          ? this.params.value
          : this.params.data && this.params.data.stopSale;
      }
      return this.value;
    },
    isStopSale() {
      return !this.isSelectAllOptionForFilter && !!this.resolvedValue;
    },
    // Kleinere Box mit Prop oder mit AG-Grid cellRendererParams
    isCompact() {
      return this.compact || !!this.params?.compact;
    },
  },
};
</script>

<style scoped>
/* Ohne Flex-Container sitzt das Icon auf der Textgrundlinie statt mittig */
.custom-icon-exclamation {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.stop-sale-icon {
  color: var(--danger);
}
</style>
